






































































import { Vue, Component, Watch } from 'vue-property-decorator';
import {namespace} from "vuex-class";

import Dialog from "@/views/Dialog/Dialog.vue";
import ResendVerification from "@/views/Dialog/views/ResendVerification.vue";
import InfoSaveMoney from "@/views/Dialog/views/InfoSaveMoney.vue";
import ExternalShipment from "@/views/Dialog/views/ExternalShipment.vue";
import ShipmentInfo from "@/views/Dialog/views/ShipmentInfo.vue";
import NotAvailable from "@/views/Dialog/views/NotAvailable.vue";
import SelectDefaultHubDialog from "@/views/Dialog/views/SelectDefaultHubDialog.vue";
import CancelShipmentDialog from "@/views/Dialog/views/CancelShipmentDialog.vue";
import {initialShipment, IActiveShipment} from "@/models/StoreModels";
import TosText from "@/views/Dialog/views/TosText.vue";
import TemporalServiceInterruption from "@/views/Dialog/views/TemporalServiceInterruption.vue";
import {IOnOffHandlers} from "@/models/IOnOffHandlers";

const userData = namespace("userData");

enum EDialogOptions {
  RESEND_VERIFICATION = 'RESEND_VERIFICATION',
  DEFAULT_HUB = 'DEFAULT_HUB',
  INFO_SAVE_MONEY = 'INFO_SAVE_MONEY',
  ORDER_EXTERNAL = 'ORDER_EXTERNAL',
  NOT_AVAILABLE = 'NOT_AVAILABLE',
  SHIPMENT_INFO = 'SHIPMENT_INFO',
  NO_DIALOG = 'NO_DIALOG',
  SHIPMENT_CANCEL = "SHIPMENT_CANCEL",
  TOS_TEXT = "TOS_TEXT",
  TEMPORAL_INTERRUPTION = 'TEMPORAL_INTERRUPTION',
}

@Component({
  name: 'DialogSet',
  components: {
    TemporalServiceInterruption,
    Dialog,
    InfoSaveMoney,
    ResendVerification,
    ExternalShipment,
    ShipmentInfo,
    NotAvailable,
    CancelShipmentDialog,
    SelectDefaultHubDialog,
    TosText,
  },
})
export default class DialogSet extends Vue {
  @userData.Getter('userSmsWasValidated')
  private userSmsWasValidated!: boolean;

  @userData.Getter('getPhone')
  private userPhone!: boolean;

  private myEvents: IOnOffHandlers = {};

  private shipment: IActiveShipment = initialShipment();

  private dialogToShow: EDialogOptions = EDialogOptions.NO_DIALOG;

  private RESEND_VERIFICATION: EDialogOptions = EDialogOptions.RESEND_VERIFICATION;
  private DEFAULT_HUB: EDialogOptions = EDialogOptions.DEFAULT_HUB;
  private INFO_SAVE_MONEY: EDialogOptions = EDialogOptions.INFO_SAVE_MONEY;
  private ORDER_EXTERNAL: EDialogOptions = EDialogOptions.ORDER_EXTERNAL;
  private NOT_AVAILABLE: EDialogOptions = EDialogOptions.NOT_AVAILABLE;
  private SERVICE_INTERRUPTION: EDialogOptions = EDialogOptions.TEMPORAL_INTERRUPTION;
  private SHIPMENT_INFO: EDialogOptions = EDialogOptions.SHIPMENT_INFO;
  private SHIPMENT_CANCEL: EDialogOptions = EDialogOptions.SHIPMENT_CANCEL;
  private NO_DIALOG: EDialogOptions = EDialogOptions.NO_DIALOG;
  private TOS_TEXT: EDialogOptions = EDialogOptions.TOS_TEXT;

  private get resendVerificationDialogIsOpen() {
    return this.dialogToShow === this.RESEND_VERIFICATION && !this.userSmsWasValidated;
  }

  private get dialogIsOpen() {
    return this.dialogToShow !== this.NO_DIALOG;
  }

  private created() {
    this.myEvents = this.$ons({
      "dialog:infoMoney:show": this.showInfoMoney,
      "dialog:external:show": this.showExternal,
      "dialog:notAvailable:show": this.showNotAvailable,
      "dialog:shipmentInfo:show": this.showShipmentInfo,
      "dialog:shipmentCancel:show": this.showShipmentCancel,
      "dialog:resendVerification:show": this.showResendVerification,
      "dialog:defaultHub:show": this.showDefaultHub,
      "dialog:tosText:show": this.showTosText,
      "dialog:serviceInterruption:show": this.showServiceInterruption,
    });
    // open verification after 2 seconds if needed
    setTimeout(() => this.openResendVerificationOnCreation(), 2000);
  }

  private beforeDestroy() {
    this.$offs(this.myEvents);
  }

  @Watch('userSmsWasValidated')
  private openResendVerificationOnCreation() {
    if (this.userPhone && !this.userSmsWasValidated && this.dialogToShow === this.NO_DIALOG) {
      this.dialogToShow = this.RESEND_VERIFICATION;
    }
  }

  private resetDialogs() {
    this.dialogToShow = this.NO_DIALOG;
  }

  private showResendVerification() {
    this.dialogToShow = this.RESEND_VERIFICATION;
  }

  private showInfoMoney() {
    this.dialogToShow = this.INFO_SAVE_MONEY;
  }

  private showExternal() {
    this.dialogToShow = this.ORDER_EXTERNAL;
  }

  private showNotAvailable() {
    this.dialogToShow = this.NOT_AVAILABLE;
  }

  private showShipmentInfo(shipment: IActiveShipment) {
    this.dialogToShow = this.SHIPMENT_INFO;
    this.shipment = shipment;
  }

  private showShipmentCancel(shipment: IActiveShipment) {
    this.dialogToShow = this.SHIPMENT_CANCEL;
    this.shipment = shipment;
  }

  private showDefaultHub() {
    this.dialogToShow = this.DEFAULT_HUB;
  }

  private showTosText() {
    this.dialogToShow = this.TOS_TEXT;
  }
  private showServiceInterruption() {
    this.dialogToShow = this.SERVICE_INTERRUPTION;
  }
}
